<template>
  <div class="vertical-nav-header d-flex items-center pt-5 pb-2">
    <router-link to="/">
      <!-- `eager` and no transition, so that the logo does not fade in again on every navigation -->
      <v-img :src="logo" alt="logo" max-width="275" contain class="mx-4" eager :transition="false"></v-img>
    </router-link>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import { AssetRepository, AssetEnum } from "@/lib/AssetRepository";

@Component({
  components: {}
})
export default class TheNavigationDrawerHeader extends Vue {
  get logo() {
    return AssetRepository.getAsset(this.$vuetify.theme.dark, AssetEnum.damageReportLogo);
  }
}
</script>
<style scoped></style>
